export {
  default as registerServiceWorker,
  unregister,
} from './registerServiceWorker';



// WEBPACK FOOTER //
// ./src/serviceWorker/index.ts